import { NT_BOOKS, OT_BOOKS } from '../utils/bibleBooks';
import { chaptersForBook } from './storedText';

// Turning pages runs through the Bible in its printed order, Genesis to
// Revelation. The book lists elsewhere put the New Testament first; that is a
// menu order, not a reading order.
//
// A page is { book, ch }. Each book opens with its outline page (the
// introduction, author, subject and outline tree), which is `ch: null` and is
// /bible?book=Exo in the URL; its chapters follow. So the pages run
//   Genesis outline, Genesis 1 … Genesis 50, Exodus outline, Exodus 1 …
// up to Revelation 22. The Genesis outline is the first page and Revelation
// 22 the last.
export const BIBLE_ORDER = [...OT_BOOKS, ...NT_BOOKS];
const INDEX = new Map(BIBLE_ORDER.map((b, i) => [b, i]));

export const chapterCount = book => chaptersForBook(book).length;

// The book before (dir -1) or after (dir +1) `book`, or null past either end.
export function adjacentBook(book, dir) {
  const i = INDEX.get(book);
  if (i == null) return null;
  return BIBLE_ORDER[i + dir] || null;
}

// The page one turn away from book/ch, as { book, ch }, or null before the
// Genesis outline and after Revelation 22. Forward from a book's last chapter
// is the next book's outline; back from chapter 1 is this book's outline, and
// back from an outline is the previous book's last chapter.
export function stepPage(book, ch, dir) {
  if (!INDEX.has(book) || !dir) return null;
  const last = chapterCount(book);
  if (!ch) {
    if (dir > 0) return last ? { book, ch: 1 } : null;
    const prev = adjacentBook(book, -1);
    return prev ? { book: prev, ch: chapterCount(prev) } : null;
  }
  const next = ch + dir;
  if (next >= 1 && next <= last) return { book, ch: next };
  if (next < 1) return { book, ch: null };
  const other = adjacentBook(book, 1);
  return other ? { book: other, ch: null } : null;
}

// Which way a jump goes, so it turns forward or back: -1, 0 or 1. An outline
// page (ch null) comes before its book's chapter 1.
export function compareChapters(a, b) {
  const ia = INDEX.get(a.book) ?? 0, ib = INDEX.get(b.book) ?? 0;
  if (ia !== ib) return ia < ib ? -1 : 1;
  const ca = a.ch || 0, cb = b.ch || 0;
  return ca === cb ? 0 : ca < cb ? -1 : 1;
}
